/** This is an automatically generated class by FairyGUI. Please do not modify it. **/
import UI_splash from "./UI_splash";
export default class LoadBinder {
    static bindAll() {
        fgui.UIObjectFactory.setExtension(UI_splash.URL, UI_splash);
    }
}
